import {defaultPagination} from "@/services/pagination";
import {
  exportSnapshot,
  listContactBreadcrumps,
  listContacts,
  restoreSnapshot
} from "@/services/api/app/office/recovery/exchange/data-set/contact";
import {listInitialBackupStats} from "@/services/api/app/common/initialBackup";

const defaultState = () => ({
  files: [],
  searchFiles: [],
  searchPagination: {
    ...defaultPagination(),
    sortBy: 'snapshots.contact.display_name',
    sortDescending: false
  },
  pagination: {
    ...defaultPagination(),
    sortBy: 'snapshots.contact.display_name',
    sortDescending: false
  },
  folderId: null,
  breadcrumps: null,
  search: null,
  initialSearch: null,
  initialBackupStatus: {},
  filterBackupStatus: {
    provider: 1,
    module: 5,
    dataType: 0,
  },
})

export default {
  namespaced: true,

  actions: {
    listSnapshotDetails({commit, state}, data) {
      return listContacts({
        ...data,
        pagination: state.pagination,
        // folderId: state.folderId,
        // searchTerm: state?.search?.searchTerm
      })
        .then(({result, pagination}) => {
          let index = Date.parse(new Date());
          const res = result.map(file => {
            return {
              ...file,
              originalId: file.id,
              id: index++
            }
          })

          commit('setFiles', res)
          commit('setPagination', pagination)
        })
    },
    searchFiles({commit, state}, data) {
      return listContacts(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    searchSnapshotDetails({commit, state}, data) {
      return listContacts(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    listBreadcrumps({state, commit}, {userId, snapshotDate}) {
      if (state.folderId && userId && snapshotDate) {
        return listContactBreadcrumps({
          userId,
          snapshotDate,
          folderId: state.folderId
        })
          .then(result => {
            commit('setBreadcrumps', result);
          })
      } else {
        commit('setBreadcrumps', []);
        return Promise.resolve();
      }
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    },
    listInitialBackupStats({commit, state}, filter) {
      return listInitialBackupStats({
        ...state.filterBackupStatus,
        id: filter.id,
      })
        .then((result) => {
          commit('setInitialBackupStatus', result)
          return result;
        })
    },
  },

  mutations: {
    setFiles(state, files) {
      state.files = files;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearchFiles(state, files) {
      state.searchFiles = files;
    },
    setSearchPagination(state, pagination) {
      state.searchPagination = pagination;
    },
    resetSearchPagination(state) {
      state.searchPagination = {
        ...defaultPagination(),
        sortBy: 'snapshots.contact.display_name',
        sortDescending: false
      };
    },
    setFolderId(state, folderId) {
      state.folderId = folderId;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setBreadcrumps(state, breadcrumps) {
      state.breadcrumps = breadcrumps;
    },
    setInitialSearch(state, initialSearch) {
      state.initialSearch = initialSearch
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setInitialBackupStatus(state, initialBackupStatus) {
      state.initialBackupStatus = initialBackupStatus
    },

  },

  state: defaultState()
}
